<template>

  <CHeader with-subheader>

        <CToggler
      in-header
     
      @click="$store.commit('toggleSidebarDesktop')"
    />
     <CRow lg="60" class="align-items-center">
       <!--
          class="ml-3 d-md-down-none"
         class="align-items-center"
          -->
         <CCol lg="0">
          <b>Filtre<br>Période</b>
          </CCol>           
          <CCol xl class="mb-3 mb-xl-0">
            <CButton block variant="outline" color="dark" 
             @click="() => show = (show) ? false : true" ><CIcon name="cil-calendar" /></CButton>          
          </CCol>
         <CCol lg="0">
          <b>DE<br> À</b>
          </CCol>           
          <CCol  xl class="mb-3 mb-xl-0">
            {{ selectedDate.start.toLocaleDateString() }}<br/>
            {{ selectedDate.end.toLocaleDateString() }} 
            {{ setDateFilter() }}
          </CCol>

          <CCol lg='0' class="mb-3 mb-0">
            <small>
              <CButton block size='sm' variant="outline" color="dark"  v-on:click="() => setDateFilterMinus(365)"><CIcon name="cil-chevron-right" /><br>365J</CButton>
            </small>
          </CCol>
          <CCol lg='0'  class="mb-3 mb-0">
            <CButton block size='sm'variant="outline" color="dark" v-on:click="() => setDateFilterMinus(90)"><CIcon name="cil-chevron-right" /><br>90J</CButton>
          </CCol>
          <CCol lg='0'  class="mb-3 mb-0">
            <CButton block size='sm' variant="outline" color="dark"  v-on:click="() => setDateFilterMinus(30)"><CIcon name="cil-chevron-right" /><br>30J</CButton>
          </CCol>
          <CCol lg='0'  class="mb-3 mb-0">
            <CButton block size='sm' variant="outline" color="dark"  v-on:click="() => setDateFilterMinus(7)"><CIcon name="cil-chevron-right" /><br>7J</CButton>
          </CCol>
          <CCol lg='0'  class="mb-3 mb-0">
            <CButton block size='sm' variant="outline" color="dark"  v-on:click="() => setDateFilterMinus(0)"><CIcon name="cil-chevron-right" /><br>1J</CButton>
          </CCol>    

        <CCol lg="1"></CCol>              
        <CCol lg="1">
         <div v-if="$store.state.filterDevicesIMEI.length>0"><b>Filtre<br>Unités<br></b></div>
         <div v-else color="red"><b>Aucune<br>unités!<br></b></div>      
         </CCol>
         <CCol >
           <router-link to="/SN/SNdevices" >
            <CButton block variant="outline" color="dark"><CIcon name="cil-ListRich" /><br></CButton>
            </router-link>
          </CCol>    


     </CRow>               
     <CRow lg="74">
        <CCol lg="1"></CCol>     

         <CCol lg="73">
         <template>
               <small> 
              <div v-if="$store.state.filterDevices.length>0" >
                <div v-if="$store.state.filterDevices[0]!=$store.state.selectedDeviceSerial" ><CButton  v-bind:class="{active: isActive}" @click="setSelectedDevice($store.state.filterDevices[0])" variant="outline">{{$store.state.filterDevices[0]}}</CButton></div>
                <div v-else>                                                                  <CButton  v-bind:class="{active: isActive}" @click="setSelectedDevice($store.state.filterDevices[0])" color="dark">{{$store.state.filterDevices[0]}}</CButton></div>
              </div>
              <div v-if="$store.state.filterDevices.length>1" >
                <div v-if="$store.state.filterDevices[1]!=$store.state.selectedDeviceSerial" ><CButton  v-bind:class="{active: isActive}" @click="setSelectedDevice($store.state.filterDevices[1])" variant="outline">{{$store.state.filterDevices[1]}}</CButton></div>
                <div v-else>                                                                  <CButton  v-bind:class="{active: isActive}" @click="setSelectedDevice($store.state.filterDevices[1])" color="dark">{{$store.state.filterDevices[1]}}</CButton></div>
              </div>
              <div v-if="$store.state.filterDevices.length>2" >
                <div v-if="$store.state.filterDevices[2]!=$store.state.selectedDeviceSerial" ><CButton  v-bind:class="{active: isActive}" @click="setSelectedDevice($store.state.filterDevices[2])" variant="outline">{{$store.state.filterDevices[2]}}</CButton></div>
                <div v-else>                                                                  <CButton  v-bind:class="{active: isActive}" @click="setSelectedDevice($store.state.filterDevices[2])" color="dark">{{$store.state.filterDevices[2]}}</CButton></div>
              </div>
            </small>
         </template>
          </CCol>    

         <CCol lg="73">
         <template>
               <tiny> 
              <div v-if="$store.state.filterDevices.length>3" >
                <div v-if="$store.state.filterDevices[3]!=$store.state.selectedDeviceSerial" ><CButton  v-bind:class="{active: isActive}" @click="setSelectedDevice($store.state.filterDevices[3])" variant="outline">{{$store.state.filterDevices[3]}}</CButton></div>
                <div v-else>                                                                  <CButton  v-bind:class="{active: isActive}" @click="setSelectedDevice($store.state.filterDevices[3])" color="dark">{{$store.state.filterDevices[3]}}</CButton></div>
              </div>
              <div v-if="$store.state.filterDevices.length>4" >
                <div v-if="$store.state.filterDevices[4]!=$store.state.selectedDeviceSerial" ><CButton  v-bind:class="{active: isActive}" @click="setSelectedDevice($store.state.filterDevices[4])" variant="outline">{{$store.state.filterDevices[4]}}</CButton></div>
                <div v-else>                                                                  <CButton  v-bind:class="{active: isActive}" @click="setSelectedDevice($store.state.filterDevices[4])" color="dark">{{$store.state.filterDevices[4]}}</CButton></div>
              </div>
              <div v-if="$store.state.filterDevices.length>5" >
                <div v-if="$store.state.filterDevices[5]!=$store.state.selectedDeviceSerial" ><CButton  v-bind:class="{active: isActive}" @click="setSelectedDevice($store.state.filterDevices[5])" variant="outline">{{$store.state.filterDevices[5]}}</CButton></div>
                <div v-else>                                                                  <CButton  v-bind:class="{active: isActive}" @click="setSelectedDevice($store.state.filterDevices[5])" color="dark">{{$store.state.filterDevices[5]}}</CButton></div>
              </div>
            </tiny>
         </template>
          </CCol>      


         <CCol lg="73">
         <template>
               <tiny> 
              <div v-if="$store.state.filterDevices.length>6" >
                <div v-if="$store.state.filterDevices[6]!=$store.state.selectedDeviceSerial" ><CButton  v-bind:class="{active: isActive}" @click="setSelectedDevice($store.state.filterDevices[6])" variant="outline">{{$store.state.filterDevices[6]}}</CButton></div>
                <div v-else>                                                                  <CButton  v-bind:class="{active: isActive}" @click="setSelectedDevice($store.state.filterDevices[6])" color="dark">{{$store.state.filterDevices[6]}}</CButton></div>
              </div>
              <div v-if="$store.state.filterDevices.length>7" >
                <div v-if="$store.state.filterDevices[7]!=$store.state.selectedDeviceSerial" ><CButton  v-bind:class="{active: isActive}" @click="setSelectedDevice($store.state.filterDevices[7])" variant="outline">{{$store.state.filterDevices[7]}}</CButton></div>
                <div v-else>                                                                  <CButton  v-bind:class="{active: isActive}" @click="setSelectedDevice($store.state.filterDevices[7])" color="dark">{{$store.state.filterDevices[7]}}</CButton></div>
              </div>
              <div v-if="$store.state.filterDevices.length>8" >
                <div v-if="$store.state.filterDevices[8]!=$store.state.selectedDeviceSerial" ><CButton  v-bind:class="{active: isActive}" @click="setSelectedDevice($store.state.filterDevices[8])" variant="outline">{{$store.state.filterDevices[8]}}</CButton></div>
                <div v-else>                                                                  <CButton  v-bind:class="{active: isActive}" @click="setSelectedDevice($store.state.filterDevices[8])" color="dark">{{$store.state.filterDevices[8]}}</CButton></div>
              </div>
            </tiny>
         </template>
          </CCol>    

         <CCol lg="73">
         <template>
               <tiny> 
              <div v-if="$store.state.filterDevices.length>9" >
                <div v-if="$store.state.filterDevices[9]!=$store.state.selectedDeviceSerial" ><CButton  v-bind:class="{active: isActive}" @click="setSelectedDevice($store.state.filterDevices[9])" variant="outline">{{$store.state.filterDevices[9]}}</CButton></div>
                <div v-else>                                                                  <CButton  v-bind:class="{active: isActive}" @click="setSelectedDevice($store.state.filterDevices[9])" color="dark">{{$store.state.filterDevices[9]}}</CButton></div>
              </div>
              <div v-if="$store.state.filterDevices.length>10" >
                <div v-if="$store.state.filterDevices[10]!=$store.state.selectedDeviceSerial" ><CButton  v-bind:class="{active: isActive}" @click="setSelectedDevice($store.state.filterDevices[10])" variant="outline">{{$store.state.filterDevices[10]}}</CButton></div>
                <div v-else>                                                                  <CButton  v-bind:class="{active: isActive}" @click="setSelectedDevice($store.state.filterDevices[10])" color="dark">{{$store.state.filterDevices[10]}}</CButton></div>
              </div>
              <div v-if="$store.state.filterDevices.length>11" >
                <div v-if="$store.state.filterDevices[11]!=$store.state.selectedDeviceSerial" ><CButton  v-bind:class="{active: isActive}" @click="setSelectedDevice($store.state.filterDevices[11])" variant="outline">{{$store.state.filterDevices[11]}}</CButton></div>
                <div v-else>                                                                  <CButton  v-bind:class="{active: isActive}" @click="setSelectedDevice($store.state.filterDevices[11])" color="dark">{{$store.state.filterDevices[11]}}</CButton></div>
              </div>
            </tiny>
         </template>
          </CCol>             
    {{ CheckAccess() }}


           <!--
              <button v-for="(item,index) in $store.state.filterDevices">
              {{item}}
              </button>
            -->
   <CCol lg="2">
    <CHeaderNav>
      <!--
   <CHeaderNavLink>
    </CHeaderNavLink>
    <CHeaderNav class="d-md-down-none mr-auto">   
    </CHeaderNav>
      <CHeaderNavItem class="px-3">
        <button 
          @click="() => $store.commit('toggle', 'darkMode')" 
          class="c-header-nav-btn"
        >
          <CIcon v-if="$store.state.darkMode" name="cil-sun"/>
          <CIcon v-else name="cil-moon"/>
        </button>
      </CHeaderNavItem>
-->
          <CHeaderNavItem class="px-3">
            <CHeaderNavLink to="/SN/SNusers" exact>
              Users
            </CHeaderNavLink>
          </CHeaderNavItem>
          <CButton color="primary" class="px-4" v-on:click="() => Logout()">Logout</CButton>
        </CHeaderNav>
    </CCol>         
 
       </CRow>               
         <CSubheader class="px-3" v-if="show">        
 <CCard  color="gradient-secondary">
    
        <CCardHeader>
        <strong>Filtrer par période</strong>
                      <CLink href="#" class="card-header-action btn-close" v-on:click="show = false">
                  <CIcon name="cil-x-circle"/>
                </CLink>
        </CCardHeader>
        <CCardBody>
          <v-date-picker
            mode="range"
            v-model="selectedDate"
            is-inline
          />
          <!--
            @change={{ console.log("sendRange=",DatePicker); }}

            https://stackoverflow.com/questions/50957334/v-model-with-datepicker-input

          </p>
          -->
        </CCardBody>
          <CCardFooter>
        <!--
            <CButton type="Apply" size="sm" color="primary" @click="() => $store.commit('toggle', 'darkMode')" ><CIcon name="cil-check-circle" />Confimer</CButton>
          -->
          </CCardFooter>        
      </CCard> 
    </CSubheader>

        </CRow>          
    <CSubheader class="px-3">
      <CBreadcrumbRouter class="border-0 mb-0"/>
    </CSubheader>
  </CHeader>
               

</template>

<script>
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'
import TheHeaderDropdownNotif from './TheHeaderDropdownNotif'
import TheHeaderDropdownTasks from './TheHeaderDropdownTasks'
import TheHeaderDropdownMssgs from './TheHeaderDropdownMssgs'
import { DatePicker } from 'v-calendar'
const APIURL = process.env.VUE_APP_API_URL
import axios from 'axios'

const today = new Date();

// todo emit date change
export default {
  name: 'TheHeader',
  components: {
    TheHeaderDropdownAccnt,
    TheHeaderDropdownNotif,
    TheHeaderDropdownTasks,
    TheHeaderDropdownMssgs,
    'v-date-picker': DatePicker
  },
  data()
  {
    return  {
      isActive: false,
      show: false,
      initialDate: new Date(today.getFullYear(), today.getMonth(), today.getDay()),
      curDate: new Date(today.getFullYear(), today.getMonth(), today.getDay()),
      selectedDate: {
        start: new Date(today.getFullYear()-1, today.getMonth(), today.getDay()),
        end: new Date(today.getFullYear(), today.getMonth(),today.getDay())
      }
    }

  },
  /*
   beforeMount() {
       var devices;
       axios.get( APIURL+'/api1/devices', {   
         mode: 'no-cors',
              headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
          withCredentials: false
        } )
        .then(  res => { 
            devices = res.data; 
            var newSel = []
            var newSel2 = []
            for (var x=0; x<devices.length;x++)
            {
                devices[x].filter = true;
                newSel.push(devices[x].serial)
                newSel2.push(devices[x].imei)
            }
            this.$store.commit('set', [ 'filterDevices', newSel ] )
            this.$store.commit('set', [ 'filterDevicesIMEI', newSel2 ] )        
          } )
        .catch( err => console.log(err))
        .finally(() => this.loading = false) 
   },
   */
   sendRange: function () 
   {
   //    console.log("sendRange=",DatePicker)
    //this.$emit('setRange', this.rangeValue)
      var location = this.$route.fullPath
      this.$router.replace('/')
      this.$nextTick(() => this.$router.replace(location))    
   },  
   methods: {
    Logout: function()
    {
        this.$store.commit('set', [ 'Authorized', false ]  );
        console.log('login.vue:Logout(): this.$store.state.Authorized = ',this.$store.state.Authorized)
        CheckAccess();
    },     
    CheckAccess: function()
    {
       var granted=false;

      if (this.$route.query.tok != null)
      {
          // skip long than one yeay
          var d1 =  Date.now()
          var d2 = new Date( parseInt(this.$route.query.tok) )
          if ( (d1>=d2) && (d2 != 0) )
          {
            var seconds = (d1-d2)/1000
            var minutes=seconds/60;
            if (minutes<=120)
            {
              granted=true;          
              this.$store.commit('set', [ 'Authorized', true ]  );
            }
          }
      }
      if (granted==false)
       if ( (this.$store.state.Authorized == null) || (this.$store.state.Authorized  == false ))
       {
          console.log("TheHeader.vue::CheckAccess() this.$store.Authorized=",this.$store.state.Authorized)
          var location = '/pages/login'
          this.$router.replace('/')
          this.$nextTick(() => this.$router.replace(location))
       }
    },

    deviceButtonSelectColor: function ( devDisplayed )
    {
        if (devDisplayed == this.$store.devSerial)
          return ( '#0099ff;');

        return ( '#e6f5ff;');
    },
    setDevicesFilter: function ()
    {
      this.$store.commit('set', [ 'filterDateStart', this.selectedDate.start ]  );
      this.$store.commit('set', [ 'filterDateEnd', this.selectedDate.end ]  );
      //this.$forceUpdate(); 
      
    },
    setDateFilter: function ()
    {
      this.$store.commit('set', [ 'filterDateStart', this.selectedDate.start ]  );
      this.$store.commit('set', [ 'filterDateEnd', this.selectedDate.end ]  );
      //this.$forceUpdate(); 
      
    },
    setSelectedDevice: function ( devSerial )
    {
        var devSerialIMEI="";
        for (var x =0; x< this.$store.state.filterDevices.length; x++)
        {
          //  console.log("IF =",this.$store.state.filterDevices[x]);
        //    console.log("IF =",devSerial);
          if (this.$store.state.filterDevices[x] == devSerial)
          {
              devSerialIMEI=this.$store.state.filterDevicesIMEI[x];              
      //      console.log("OK  =",devSerialIMEI);
          }
        }
        // console.log("setSelectedDevice=",this.$store.state.selectedDeviceSerial);
        this.$store.commit('set', [ 'selectedDeviceSerial', devSerial ]  );
        this.$store.commit('set', [ 'selectedDeviceIMEI', devSerialIMEI ]  );
        this.isActive=!this.isActive;
     //   console.log("setSelectedDevice=",this.$store.state.selectedDeviceSerial);
     //   console.log("setSelectedDeviceIMEI=",this.$store.state.selectedDeviceIMEI);
     //   console.log("filterDevices=",this.$store.state.filterDevices);
     //   console.log("filterDevicesIMEI=",this.$store.state.filterDevicesIMEI);
     //   console.log("filterDevicesIMEI=",devSerialIMEI);
      
    },
    setDateFilterMinus: function ( days )
    {
      this.curDate=new Date();
      this.curDate.setDate(this.curDate.getDate()-days);
      this.selectedDate.end =new Date();
      this.selectedDate.start = this.curDate;      
      this.$store.commit('set', [ 'filterDateStart', this.selectedDate.start ]  );
      this.$store.commit('set', [ 'filterDateEnd', this.selectedDate.end ]  );
    //  vm.$forceUpdate(); 
      //setDateFilter();      
      //this.$router.go()
      var location = this.$route.fullPath
      this.$router.replace('/')
      this.$nextTick(() => this.$router.replace(location))
    }
  },
  computed:
  { 
    getDeviceFilter()
    {
        return this.$store.state.filterDevices
    }   
  }
}
</script>
